import { on } from 'delegated-events'
import Swiper from 'swiper'
import { A11y, Navigation } from 'swiper/modules'
import { isTouchDevice } from '@common/util'

export default {
  init: () => {
    document.querySelectorAll('.callout-cards').forEach((el) => {
      const container = el.querySelector('.swiper')
      const viewAllToggles = el.querySelectorAll('.view-all-toggle')

      const swiper = new Swiper(container, {
        modules: [A11y, Navigation],
        slidesPerView: 1,
        navigation: {
          nextEl: el.querySelector('.slider-button-next'),
          prevEl: el.querySelector('.slider-button-prev'),
        },
        loop: true,
        allowTouchMove: false,
        breakpoints: {
          768: {
            slidesPerView: 'auto',
          },
        },
      })

      if (viewAllToggles.length) {
        viewAllToggles.forEach((button) => {
          button.addEventListener('click', () => {
            el.classList.toggle('is-view-all')

            if (el.classList.contains('is-view-all')) {
              swiper.slideTo(0, 0)
              swiper.disable()
            } else {
              swiper.enable()
            }
          })
        })
      }
    })

    on('mouseover', '.callout-card:not(.is-active)', (e) => {
      e.currentTarget.classList.add('is-active')
    })

    on('mouseout', '.callout-card', (e) => {
      e.currentTarget.classList.remove('is-active')
    })

    if (isTouchDevice) {
      on('click', '.callout-card-content', (e) => {
        e.currentTarget.closest('.callout-card').classList.remove('is-active')
      })
    }
  },
}
